import React, { Component } from 'react';

class Tabs extends Component {

    state = {
        tabSelected: 0
    };

    handleClick = (tab) => {
        const { handleClick } = this.props;
        this.setState({tabSelected: tab});
        if(handleClick){
            handleClick(tab);
        }
    }

    render() {
        const { tabSelected } = this.state;
        const { tabs } = this.props;

        return (
            <div className='content-tabs'>
                <ul>
                    {tabs && tabs.map((item, key) => (
                        <li key={key} className={tabSelected === key ? 'active' : ''} onClick={() => this.handleClick(key)}>{item}</li>
                    ))}
                    <li className='finish no-mobile'></li>
                </ul>
            </div>   
        );
  }
}

export default Tabs;